import { NoddiButton, NoddiDialog, useAppForm } from 'noddi-ui-web';
import { z } from 'zod';

const FORM_ID = 'adapter-review-case-note-form';

const noteSchema = z.object({
  note: z.string().trim().min(1, 'A note is required')
});

type FormValues = z.input<typeof noteSchema>;

type Props = {
  open: boolean;
  title: string;
  description: string;
  onClose: () => void;
  onSubmit: (note: string) => Promise<void>;
};

export function AdapterReviewCaseNoteDialog({ open, title, description, onClose, onSubmit }: Props) {
  const form = useAppForm({
    defaultValues: { note: '' } satisfies FormValues,
    validators: { onSubmit: noteSchema },
    onSubmit: async ({ value }) => {
      await onSubmit(value.note.trim());
      form.reset();
    }
  });

  const handleClose = () => {
    form.reset();
    onClose();
  };

  return (
    <form.AppForm>
      <NoddiDialog
        open={open}
        onClose={handleClose}
        title={title}
        description={description}
        maxWidth='md'
        footer={
          <div className='flex justify-end gap-2'>
            <NoddiButton variant='outline' onClick={handleClose}>
              Cancel
            </NoddiButton>
            <form.SubscribeButton formId={FORM_ID} label='Submit' />
          </div>
        }
      >
        <form
          id={FORM_ID}
          onSubmit={(event) => {
            event.preventDefault();
            event.stopPropagation();
            form.handleSubmit();
          }}
          className='flex flex-col gap-4'
        >
          <form.AppField name='note'>
            {(field) => <field.Input label='Note' placeholder='Enter a note' />}
          </form.AppField>
        </form>
      </NoddiDialog>
    </form.AppForm>
  );
}
